/**
 * @fileoverview Action type constants for tasks.
 */
export const ADD_TASK = "3pe/tasks/ADD_TASK";
export const ADD_TASK_WITH_PHASE_GROUP = "3pe/tasks/ADD_TASK_WITH_PHASE_GROUP";
export const REMOVE_TASK = "3pe/tasks/REMOVE_TASK";
export const EDIT_TASK_VALUE = "3pe/tasks/EDIT_TASK_VALUE";
export const CLEAR_ALL_TASKS = "3pe/tasks/CLEAR_ALL_TASKS";
export const MOVE_TASK_UP = "3pe/tasks/MOVE_TASK_UP";
export const MOVE_TASK_DOWN = "3pe/tasks/MOVE_TASK_DOWN";
export const DUPLICATE_TASK = "3pe/tasks/DUPLICATE_TASK";
export const LOAD_STATE = "LOAD_STATE";
